import { Guides } from "./components/guides.js";
import { HeroCrossfade } from "./components/hero-crossfade.js";
import { MobileMenu } from "./components/mobile-menu.js";
import { ServicesGraphic } from "./components/services-graphic.js";
import { Carousel } from "./components/carousel.js";
import { ProjectsFilter } from "./components/projects-filter.js";
import { ProjectAccordion } from "./components/project-accordion.js";
import { ProjectColorize } from "./components/project-colorize.js";

new Guides();
new HeroCrossfade();
new MobileMenu();
new ServicesGraphic();
new Carousel();
new ProjectsFilter();
new ProjectAccordion();
new ProjectColorize();
